module.exports = __webpack_public_path__ + "static/img/list_bgi.85e8da4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/list_bgi.png
// module id = 4vrU
// module chunks = 1